import React, { useState } from 'react';
import { formatNumber } from './utils';
import ModalWrapper from './ModalWrapper';

import { useEffect } from 'react';

export default function CheckInOutModal({ open, mode, item, items, customers, onClose, onSuccess }) {
  const [barcode, setBarcode] = useState('');
  const [productCodeSearch, setProductCodeSearch] = useState('');
  const [manual, setManual] = useState(false);
  const [clientId, setClientId] = useState('');
  const [description, setDescription] = useState('');
  const [variant, setVariant] = useState('');
  const [filteredItems, setFilteredItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [qty, setQty] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  // New for check-out/discard
  const [orderNumber, setOrderNumber] = useState('');

  // Reset all modal state when opening
  useEffect(() => {
    if (open) {
      if (typeof item === 'object' && item) {
        setBarcode(item.barcode || '');
        setProductCodeSearch(item.productCode || '');
        setClientId(item.clientId || '');
        setDescription(item.mainCategory || item.description || '');
        setVariant(item.variantDesc || item.variant || '');
        setSelectedItem(item); // Instantly select the item for check-in/out
      } else {
        setBarcode('');
        setProductCodeSearch('');
        setClientId('');
        setDescription('');
        setVariant('');
        setSelectedItem(null);
      }
      setManual(false);
      setFilteredItems([]);
      setQty('');
      setError('');
      setSubmitting(false);
      setOrderNumber('');
    }
  }, [open]);

  if (!open) return null;


  // Filter logic for manual selection
  function filterItems(clientId, description, variant) {
    return items.filter(i =>
      (!clientId || i.clientId === clientId) &&
      (!description || i.mainCategory === description) &&
      (!variant || i.variantDesc === variant)
    );
  }

  function handleBarcodeEnter(e) {
    if (e.key === 'Enter' && barcode) {
      const found = items.find(i => (i.barcode || '').toLowerCase() === barcode.toLowerCase());
      if (found) {
        setSelectedItem(found);
        setError('');
      } else {
        setError('No item found for that barcode. Try manual selection.');
        setManual(true);
      }
    }
  }

  function handleProductCodeEnter(e) {
    if (e.key === 'Enter' && productCodeSearch) {
      const found = items.find(i => (i.productCode || '').toLowerCase() === productCodeSearch.toLowerCase());
      if (found) {
        setSelectedItem(found);
        setError('');
      } else {
        setError('No item found for that product code. Try manual selection.');
        setManual(true);
      }
    }
  }

  function handleManualFilter() {
    const filtered = filterItems(clientId, description, variant);
    setFilteredItems(filtered);
    setSelectedItem(null);
    setError(filtered.length === 0 ? 'No items found for selected filters.' : '');
  }

  function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (!selectedItem) {
      setError('Select an item to check ' + (mode === 'in' ? 'in' : 'out'));
      return;
    }
    const nQty = Number(qty);
    if (!nQty || nQty <= 0) {
      setError('Enter a valid quantity.');
      return;
    }
    if (mode === 'out' && !orderNumber) {
      setError('Work Ticket Nr is required.');
      return;
    }
    setSubmitting(true);
    fetch(`${process.env.REACT_APP_API_URL || ''}/items/${selectedItem.id}/${mode === 'in' ? 'checkin' : 'checkout'}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ quantity: nQty, orderNumber: mode === 'out' ? orderNumber : undefined })
    })
      .then(res => {
        if (!res.ok) return res.json().then(err => { throw new Error(err.error || 'Failed'); });
        return res.json();
      })
      .then(updated => {
        onSuccess(updated);
      })
      .catch(err => setError(err.message))
      .finally(() => setSubmitting(false));
  }

  return (
    <ModalWrapper open={open} onClose={onClose} zIndex={40} minWidth={370} maxWidth={420}>
      <form onSubmit={handleSubmit} style={{
        background: 'linear-gradient(135deg, #f8fafc 70%, #e3f2fd 100%)',
        padding: 32,
        borderRadius: 16,
        minWidth: 'unset',
        maxWidth: 'unset',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 8px 32px 0 rgba(60,60,100,0.18)',
        display: 'flex',
        flexDirection: 'column',
        gap: 18
      }}>
        <h2 style={{marginBottom: 12, fontWeight: 700, color: '#1976d2', letterSpacing: 1}}>{mode === 'in' ? 'Check In' : 'Check Out'} Stock</h2>
        <div style={{display:'flex', flexDirection:'column', gap:10}}>
          <label style={{fontWeight:500,marginBottom:2}}>Scan Barcode</label>
          <div style={{display:'flex',gap:8}}>
            <input
              autoFocus
              value={barcode}
              onChange={e => setBarcode(e.target.value)}
              placeholder="Scan barcode or type manually"
              disabled={manual || !!selectedItem}
              style={{flex:1,padding:10, borderRadius:6, border:'1px solid #bdbdbd'}}
              onKeyDown={handleBarcodeEnter}
            />
            <button type="button"
              disabled={manual || !!selectedItem || !barcode}
              style={{background:'#1976d2',color:'white',fontWeight:600,padding:'8px 18px',border:'none',borderRadius:8,boxShadow:'0 2px 8px #1976d233'}}
              onClick={() => {
                const found = items.find(i => (i.barcode || '').toLowerCase() === barcode.toLowerCase());
                if (found) {
                  setSelectedItem(found);
                  setError('');
                } else {
                  setError('No item found for that barcode. Try manual selection.');
                  setManual(true);
                }
              }}
            >Search</button>
          </div>
        </div>
        <div style={{display:'flex', flexDirection:'column', gap:10}}>
  <label style={{fontWeight:500,marginBottom:2}}>Product Code</label>
  <div style={{display:'flex',gap:8}}>
    <input
      value={productCodeSearch}
      onChange={e => setProductCodeSearch(e.target.value)}
      placeholder="Enter product code"
      disabled={manual || !!selectedItem}
      style={{flex:1,padding:10, borderRadius:6, border:'1px solid #bdbdbd'}}
      onKeyDown={handleProductCodeEnter}
    />
    <button type="button"
      disabled={manual || !!selectedItem || !productCodeSearch}
      style={{background:'#1976d2',color:'white',fontWeight:600,padding:'8px 18px',border:'none',borderRadius:8,boxShadow:'0 2px 8px #1976d233'}}
      onClick={() => {
        const found = items.find(i => (i.productCode || '').toLowerCase() === productCodeSearch.toLowerCase());
        if (found) {
          setSelectedItem(found);
          setError('');
        } else {
          setError('No item found for that product code. Try manual selection.');
          setManual(true);
        }
      }}
      >Search</button>
  </div>
</div>
        <div style={{margin:'8px 0',textAlign:'center', color:'#888', fontWeight:500}}>or</div>
<button type="button" onClick={()=>setManual(true)} style={{marginBottom:8, background:'#1976d2',color:'white',padding:'8px 20px',border:'none',borderRadius:8,fontWeight:600,boxShadow:'0 2px 8px #1976d233'}} disabled={manual}>Manual Select</button>
        {manual && (
          <>
            <div style={{display:'flex', flexDirection:'column', gap:10}}>
  <label style={{fontWeight:500,marginBottom:2}}>Customer</label>
  <select value={clientId} onChange={e=>{setClientId(e.target.value); setDescription(''); setVariant('');}} style={{padding:10, borderRadius:6, border:'1px solid #bdbdbd'}}>
    <option value="">Select Customer</option>
    {customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
  </select>
</div>
            <div style={{display:'flex', flexDirection:'column', gap:10}}>
  <label style={{fontWeight:500,marginBottom:2}}>Description</label>
  <select value={description} onChange={e=>{setDescription(e.target.value); setVariant('');}} style={{padding:10, borderRadius:6, border:'1px solid #bdbdbd'}}>
    <option value="">Select Description</option>
    {[...new Set(items.filter(i=>!clientId||i.clientId===clientId).map(i=>i.mainCategory))].map(desc => (
      <option key={desc} value={desc}>{desc}</option>
    ))}
  </select>
</div>
            <div style={{display:'flex', flexDirection:'column', gap:10}}>
  <label style={{fontWeight:500,marginBottom:2}}>Variant</label>
  <select value={variant} onChange={e=>setVariant(e.target.value)} style={{padding:10, borderRadius:6, border:'1px solid #bdbdbd'}}>
    <option value="">Select Variant</option>
    {[...new Set(items.filter(i=>(!clientId||i.clientId===clientId)&&(!description||i.mainCategory===description)).map(i=>i.variantDesc))].map(variant => (
      <option key={variant} value={variant}>{variant}</option>
    ))}
  </select>
</div>
            <button type="button" onClick={handleManualFilter} style={{marginBottom:8, background:'#1976d2',color:'white',padding:'8px 20px',border:'none',borderRadius:8,fontWeight:600,boxShadow:'0 2px 8px #1976d233'}}>Show Items</button>
            {filteredItems.length > 0 && (
              <div style={{marginBottom:8}}>
                <label>Select Item:</label>
                <select value={selectedItem ? selectedItem.id : ''} onChange={e=>{
                  const found = filteredItems.find(i=>i.id===e.target.value);
                  setSelectedItem(found||null);
                }} style={{width:'100%'}}>
                  <option value="">Choose item</option>
                  {filteredItems.map(i => (
                    <option key={i.id} value={i.id}>{i.mainCategory} / {i.variantDesc} / {i.productCode}</option>
                  ))}
                </select>
              </div>
            )}
          </>
        )}
        {selectedItem && (
          <div style={{background:'#f1f8e9',padding:10,borderRadius:8,marginBottom:8}}>
  <div><b>Item:</b> {selectedItem.mainCategory} / {selectedItem.variantDesc} / {selectedItem.productCode}</div>
  {selectedItem.barcode && (
    <div><b>Barcode:</b> {selectedItem.barcode}</div>
  )}
  {selectedItem.labelSize && (
    <div><b>Label Size:</b> {selectedItem.labelSize}</div>
  )}
  <div><b>Current Qty:</b> {formatNumber(selectedItem.currentQty)}</div>
</div>
        )}
        <div style={{display:'flex', flexDirection:'column', gap:10}}>
  <label style={{fontWeight:500,marginBottom:2}}>Quantity</label>
  <input type="number" value={qty} onChange={e=>setQty(e.target.value)} min={1} style={{padding:10, borderRadius:6, border:'1px solid #bdbdbd'}} disabled={!selectedItem}/>
</div>

{/* Work Ticket Nr (Check Out only, not discarding) */}
{mode === 'out' && (
  <div style={{display:'flex', flexDirection:'column', gap:10}}>
    <label style={{fontWeight:500,marginBottom:2}}>Work Ticket Nr</label>
    <input type="number" value={orderNumber || ''} onChange={e=>setOrderNumber(e.target.value)} placeholder="e.g., 3456 (WT will be added automatically)" required style={{padding:10, borderRadius:6, border:'1px solid #bdbdbd'}} disabled={!selectedItem}/>
  </div>
)}

{error && <div style={{color:'red',marginBottom:8}}>{error}</div>}
<div style={{display:'flex',gap:16,justifyContent:'center',marginTop:12}}>
  <button type="submit" disabled={!selectedItem || submitting} style={{background:mode==='out'?'#fb8c00':'#43a047',color:'white',fontWeight:600,padding:'10px 32px',border:'none',borderRadius:8,boxShadow:mode==='out'?'0 2px 8px #fb8c0033':'0 2px 8px #1976d233',fontSize:16}}>{submitting ? 'Processing...' : (mode === 'in' ? 'Check In' : 'Check Out')}</button>
  <button type="button" onClick={onClose} style={{background:'#fff',color:'#1976d2',fontWeight:600,padding:'10px 32px',border:'1.5px solid #1976d2',borderRadius:8,fontSize:16}}>Cancel</button>
</div>
      </form>
    </ModalWrapper>
  );
}
